import { BUILDING_LIST, CITY, GST, HSN, CONSTITUTION, DOCNAMES_LIST, POC_DESIGNATION, ELECTRICITY_CONNECTION, INVESTOR_TYPE, LOADER, LOGIN, PERMISSION_TYPE, PROJECT_LIST, ON_BASIS, REDIRECTLINK, REGISTRATION_SUCCESS_MODAL_TOGGLE, SUCCESSINFO, SUCCESS_MODAL_TOGGLE, USERDATA, USERID, VILLAGES_LIST, WATER_SUPPLY, WORNING_MODAL_TOGGLE, BUILDING_TYPE, GALA_LIST, SOLD_GALA_LIST, FLOOR_TYPE, LOT_INTENT, DGST, AGEMODAL, QUERY, RESELLREASON, USERPROJECT, PROFILEIMG, WORNING_MODAL_TOGGLE2, SENDFROMTYPE } from "./Types";

export const loginAction = (data) => {
    return {
        data: data,
        type: LOGIN
    }
};

export const UseridAction = (userid) => {
    return {
        data: userid,
        type: USERID
    }
};
export const UserDataAction = (userdata) => {
    return {
        data: userdata,
        type: USERDATA
    }
};
export const successModalToggle = () => {
    return {
        type: SUCCESS_MODAL_TOGGLE
    }
};

export const registrationSuccessModalToggle = () => {
    return {
        type: REGISTRATION_SUCCESS_MODAL_TOGGLE
    }
};

export const loaderAction = () => {
    return {
        type: LOADER
    }
};

export const warningModalToggle = (id) => {
    return {
        type: WORNING_MODAL_TOGGLE,
        id
    }
};
export const warningModalToggle2 = (id) => {
    return {
        type: WORNING_MODAL_TOGGLE2,
        id
    }
};

export const getProjectAction = (projectList) => {
    return {
        type: PROJECT_LIST,
        projectData: projectList
    }
};

export const getBuildingAction = (buildingList) => {
    return {
        type: BUILDING_LIST,
        buildingData: buildingList
    }
}
export const getVillagesAction = (villagesList) => {
    return {
        type: VILLAGES_LIST,
        villagesData: villagesList
    }
}

export const getInvestorTypeAction = (investortype) => {
    return {
        type: INVESTOR_TYPE,
        investortypeData: investortype
    }
}
export const getPermissionTypeAction = (permissiontype) => {
    return {
        type: PERMISSION_TYPE,
        permissiontypeData: permissiontype
    }
}
export const getOnBasisAction = (onBasis) => {
    return {
        type: ON_BASIS,
        onBasisData: onBasis
    }
}
export const getWaterSupplyAction = (watersupply) => {
    return {
        type: WATER_SUPPLY,
        watersupplyData: watersupply
    }
}
export const getElectricityConnectionAction = (electricityconnection) => {
    return {
        type: ELECTRICITY_CONNECTION,
        electricityconnectionData: electricityconnection
    }
}
export const getCityAction = (cityList) => {
    return {
        type: CITY,
        CityData: cityList
    }
};
export const getConstitutionAction = (constitutionList) => {
    return {
        type: CONSTITUTION,
        ConstitutionData: constitutionList
    }
};

export const successInfoAction = (successinfo) => {
    return {
        type: SUCCESSINFO,
        successInfoData: successinfo
    }
};

export const linkRedirectAction = (linkRedirect) => {
    return {
        type: REDIRECTLINK,
        linkRedirectData: linkRedirect
    }
};

export const getDocNamesList = (docnames) => {
    return {
        type: DOCNAMES_LIST,
        docnameslistData: docnames
    }
}
export const getPocDesignation = (pocDes) => {
    return {
        type: POC_DESIGNATION,
        PocDesignationData: pocDes
    }
}
export const getBuildingTypeAction = (building_type) => {
    return {
        type: BUILDING_TYPE,
        buildingTypeData: building_type
    }
}
export const getGalaAction = (galaList) => {
    return {
        type: GALA_LIST,
        galaData: galaList
    }
}
export const getSoldGalaAction = (soldGalaList) => {
    return {
        type: SOLD_GALA_LIST,
        soldGalaData: soldGalaList
    }
}

export const getFloorTypeAction = (floor_type) => {
    return {
        type: FLOOR_TYPE,
        floorTypeData: floor_type
    }
}

export const getLotIntentAction = (lot_intent) => {
    return {
        type: LOT_INTENT,
        lotIntentData: lot_intent
    }
}
export const getGSTAction = (gst) => {
    return {
        type: GST,
        gstData: gst
    }
}

export const getHSNAction = (hsn) => {
    return {
        type: HSN,
        hsnData: hsn
    }
}
export const getDefaultGstAction = (dgst) => {
    return {
        type: DGST,
        dgst: dgst
    }
}
export const getAgeingModalAction = (agemodaldata) => {
    return {
        type: AGEMODAL,
        agemodaldata: agemodaldata
    }
}
export const getQueryAction = (querydata) => {
    return {
        type: QUERY,
        query: querydata
    }
}
export const getResellReasonAction = (reasondata) => {
    return {
        type: RESELLREASON,
        reason: reasondata
    }
}
export const getUserProjectAction = (userproject) => {
    return {
        type: USERPROJECT,
        userproject: userproject
    }
}
export const getProfileImage = (userimg) => {
    return {
        type: PROFILEIMG,
        userimg: userimg
    }
}

export const getSendFromAction = (sendFromData) => {
    return {
        type: SENDFROMTYPE,
        data: sendFromData
    }
}
